export const getConfigStyle = (flowConfig, mode) => {
  return {
    draggable: mode === "layout",
    screenshot: {
      border: `${flowConfig.taskBorderWidth}px solid ${flowConfig.taskBorderColor}`,
      padding: `${flowConfig.taskPaddingV}px ${flowConfig.taskPaddingH}px`,
      borderRadius: flowConfig.taskBorderRadius,
      color: flowConfig.taskFontColor,
      fontSize: flowConfig.taskFontSize,
      fontWeight: flowConfig.taskFontWeight,
      lineHeight: `${flowConfig.taskLineHeight / 10}em`,
      backgroundColor: flowConfig.taskBackgroundColor,
      width: flowConfig.taskWidth,
      buttons: {
        next: {
          backgroundColor: flowConfig.questionNextBackground,
          color: flowConfig.questionNextColor,
        },
      },
      detailStyle: {
        cursor: "default",
        position: "absolute",
        backgroundColor: flowConfig.screenshotDetailStyleBackground,
        border: `${flowConfig.screenshotDetailStyleBorderWidth}px solid ${flowConfig.screenshotDetailStyleBorderColor}`,
        borderRadius: flowConfig.screenshotDetailStyleBorderRadius,
        padding: flowConfig.screenshotDetailStylePadding,
        pointerEvents: "none",
        color: flowConfig.screenshotDetailStyleColor,
        fontSize:flowConfig.screenshotDetailStyleFontSize,
        fontWeight:flowConfig.screenshotDetailStyleFontWeight,
      },
      displayStyle: {
        backgroundColor: flowConfig.screenshotDisplayStyleBackground,
        padding: flowConfig.screenshotDisplayStylePadding,
        flexGrow: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: flowConfig.screenshotDisplayStyleColor,
        fontSize:flowConfig.screenshotDisplayStyleFontSize,
        fontWeight:flowConfig.screenshotDisplayStyleFontWeight,
      },
      labelStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: `${flowConfig.screenshotLabelStyleBorderWidth}px solid ${flowConfig.screenshotLabelStyleBorderColor}`,
        borderRadius: flowConfig.screenshotLabelStyleBorderRadius,
        padding: flowConfig.screenshotLabelStylePadding,
        backgroundColor: flowConfig.screenshotLabelStyleBackground,
        color: flowConfig.screenshotLabelStyleColor,
        cursor: "pointer",
        fontSize:flowConfig.screenshotLabelStyleFontSize,
        fontWeight:flowConfig.screenshotLabelStyleFontWeight,
      },
    },
    end: {
      border: `${flowConfig.instructionBorderWidth}px solid ${flowConfig.instructionBorderColor}`,
      padding: `${flowConfig.instructionPaddingV}px ${flowConfig.instructionPaddingH}px`,
      borderRadius: flowConfig.instructionBorderRadius,
      color: flowConfig.instructionFontColor,
      fontSize: flowConfig.instructionFontSize,
      fontWeight: flowConfig.instructionFontWeight,
      lineHeight: `${flowConfig.instructionLineHeight / 10}em`,
      backgroundColor: flowConfig.instructionBackgroundColor,
      width: flowConfig.instructionWidth,
      cursor: "default",
    },
    message: {
      border: `${flowConfig.instructionBorderWidth}px solid ${flowConfig.instructionBorderColor}`,
      padding: `${flowConfig.instructionPaddingV}px ${flowConfig.instructionPaddingH}px`,
      borderRadius: flowConfig.instructionBorderRadius,
      color: flowConfig.instructionFontColor,
      fontSize: flowConfig.instructionFontSize,
      fontWeight: flowConfig.instructionFontWeight,
      lineHeight: `${flowConfig.instructionLineHeight / 10}em`,
      backgroundColor: flowConfig.instructionBackgroundColor,
      width: flowConfig.instructionWidth,
      cursor: "default",
    },
    placeholder: {
      backgroundColor: "pink",
      width: flowConfig.instructionWidth,
      border: `${flowConfig.instructionBorderWidth}px solid ${flowConfig.instructionBorderColor}`,
      padding: `${flowConfig.instructionPaddingV}px ${flowConfig.instructionPaddingH}px`,
      borderRadius: flowConfig.instructionBorderRadius,
      color: flowConfig.instructionFontColor,
      fontSize: flowConfig.instructionFontSize,
      fontWeight: flowConfig.instructionFontWeight,
      lineHeight: `${flowConfig.instructionLineHeight / 10}em`,
      height: 100,
    },
    select: {
      border: `${flowConfig.selectBorderWidth}px solid ${flowConfig.selectBorderColor}`,
      padding: `${flowConfig.selectPaddingV}px ${flowConfig.selectPaddingH}px`,
      borderRadius: flowConfig.selectBorderRadius,
      color: flowConfig.selectFontColor,
      fontSize: flowConfig.selectFontSize,
      fontWeight: flowConfig.selectFontWeight,
      lineHeight: `${flowConfig.selectLineHeight / 10}em`,
      backgroundColor: flowConfig.selectBackgroundColor,
      cursor: "default",
    },
    question: {
      border: `${flowConfig.questionBorderWidth}px solid ${flowConfig.questionBorderColor}`,
      padding: `${flowConfig.questionPaddingV}px ${flowConfig.questionPaddingH}px`,
      borderRadius: flowConfig.questionBorderRadius,
      color: flowConfig.questionFontColor,
      fontSize: flowConfig.questionFontSize,
      fontWeight: flowConfig.questionFontWeight,
      lineHeight: `${flowConfig.questionLineHeight / 10}em`,
      backgroundColor: flowConfig.questionBackgroundColor,
      width: flowConfig.questionWidth,
      cursor: "default",
    },
    start: {
      border: `${flowConfig.startBorderWidth}px solid ${flowConfig.startBorderColor}`,
      padding: `${flowConfig.startPaddingV}px ${flowConfig.startPaddingH}px`,
      borderRadius: flowConfig.startBorderRadius,
      color: flowConfig.startFontColor,
      fontSize: flowConfig.startFontSize,
      fontWeight: flowConfig.startFontWeight,
      lineHeight: `${flowConfig.startLineHeight / 10}em`,
      backgroundColor: flowConfig.startBackgroundColor,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: flowConfig.startWidth,
      cursor: "pointer",
    },
    popups: {
      label: {
        // width: flowConfig.popupLabelWidth,
        border: `${flowConfig.popupLabelBorderWidth}px solid ${flowConfig.popupLabelBorderColor}`,
        borderRadius: flowConfig.popupLabelBorderRadius,
        padding: flowConfig.popupLabelPadding,
        marginTop: flowConfig.popupLabelMarginTop,
        cursor: "pointer",
        backgroundColor: flowConfig.popupLabelBackgroundColor,
        fontSize: flowConfig.popupLabelFontSize,
        fontWeight: flowConfig.popupLabelFontWeight,
        color: flowConfig.popupLabelFontColor,
      },
    },
    buttons: {
      yes: {
        backgroundColor: flowConfig.questionYesBackground,
        color: flowConfig.questionYesColor,
      },
      no: {
        backgroundColor: flowConfig.questionNoBackground,
        color: flowConfig.questionNoColor,
      },
      next: {
        backgroundColor: flowConfig.questionNextBackground,
        color: flowConfig.questionNextColor,
      },
      fontSize: flowConfig.questionButtonFont,
      fontWeight: flowConfig.questionButtonFontWeight,
      gap: flowConfig.questionButtonGap,
      border: {
        color: flowConfig.questionButtonBorderColor,
        width: flowConfig.questionButtonBorderWidth,
        radius: flowConfig.questionButtonBorderRadius,
      },
      padding: {
        vertical: flowConfig.questionButtonPaddingV,
        horizontal: flowConfig.questionButtonPaddingH,
      },
    },
    handles: { backgroundColor: flowConfig.handleBackgroundColor },
    labels: {
      fontSize: flowConfig.labelFontSize,
      fontWeight: flowConfig.labelFontWeight,
      fill: flowConfig.labelTextColor,
      backgroundColor: {
        Yes: flowConfig.labelYesBackground,
        No: flowConfig.labelNoBackground,
      },
      borderRadius: flowConfig.labelBgBorderRadius,
      paddingH: flowConfig.labelBgPaddingH,
      paddingV: flowConfig.labelBgPaddingV,
    },
    labelBgStyleYes: { fill: flowConfig.labelYesBackground },
    labelBgStyleNo: { fill: flowConfig.labelNoBackground },
    labelBgBorderRadius: flowConfig.labelBgBorderRadius,
    labelBgPadding: [flowConfig.labelBgPaddingH, flowConfig.labelBgPaddingV],
    edges: {
      type: flowConfig.edgeType,
      lineStyle: {
        stroke: flowConfig.edgeStroke,
        strokeWidth: flowConfig.edgeStrokeWidth,
      },
      marker: {
        end: {
          type: flowConfig.markerEndType,
          color: flowConfig.markerEndColor,
          height: flowConfig.markerEndHeight,
          width: flowConfig.markerEndWidth,
        },
      },
    },
  };
};
